import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import upperFirst from 'lodash.upperfirst';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getWrappedValueWithLink } from '../../../../helpers';
import { parseBooleanValues } from '../../helpers';
import { withTitle } from '../../../../HOC';
const LargeSummaryContent = ({
  summaryPropsWithContent
}) => {
  const {
    itemId
  } = useContext(MainContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "stats__wrapper"
  }, summaryPropsWithContent.map(([key, value, link, modifier], index) => {
    const dynamicKey = [itemId, index].join('-');
    const wrappedValue = parseBooleanValues(getWrappedValueWithLink(value, link, itemId), upperFirst(key));
    return /*#__PURE__*/React.createElement("div", {
      key: dynamicKey,
      className: "stats__block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "stats__text"
    }, /*#__PURE__*/React.createElement("div", {
      className: `stats__title ${modifier}`
    }, upperFirst(key)), wrappedValue && /*#__PURE__*/React.createElement("div", {
      className: `stats__value ${modifier}`
    }, wrappedValue)));
  }));
};
LargeSummaryContent.propTypes = {
  summaryPropsWithContent: PropTypes.array.isRequired
};
export default withTitle(LargeSummaryContent);
//# sourceMappingURL=LargeSummaryContent.js.map